import React from 'react'
import { Box, Flex, Stack } from '@chakra-ui/react'
import { useQuery } from '@tanstack/react-query'
import { Sidebar } from '../../layouts/Sidebar'
import { Header } from '../../layouts/Header'
import { Accredited as TAccredited } from '../../@types/entities/entities.types'
import { isEmpty } from 'lodash'
import { useAuth } from '../../hooks/useAuth'
import { AccreditedTable } from './Table'
import { axios } from '../../services/axios'

export default function Accredited() {
  const { user } = useAuth()

  const { data, isLoading, isRefetching } = useQuery(
    ['accredited'],
    fetchAccredited,
    {
      enabled: !isEmpty(user),
    }
  )

  async function fetchAccredited() {
    const response = await axios().get<TAccredited[]>(
      `/accredited/${user?.parking.id}/parking`
    )
    return response.data
  }

  return (
    <Box as="section" bg="#F4F4F4" minH="100vh">
      <Sidebar />
      <Box ml={{ base: '0', notebook: '12.3125rem' }} transition=".3s ease">
        <Header title="Credenciados" />

        <Stack as="main" direction="column" spacing="1.8125rem" padding="2rem">
          <Flex
            width="full"
            alignItems="center"
            justifyContent="center"
            background={isLoading ? 'transparent' : 'white'}
            borderRadius="md"
          >
            <AccreditedTable
              results={data!}
              filter="name"
              placeholder="Buscar credenciado"
              isLoading={isLoading}
              isRefetching={isRefetching}
            />
          </Flex>
        </Stack>
      </Box>
    </Box>
  )
}
